export default {
    'loyalty': 'Loyalty',
    'religion': 'Religion',
    'personality': 'Personality',
    'birthdate-client': 'Birthdate client',
    'weekend': 'Weekend',
    'near-by-pharmacies-one': 'Near by Pharmacies',
    'nearbyPharmaciesTwo': 'Near by Pharmacies Two',
    'works-in-centers': 'Works in centers',
    'work-hour-from': 'Work hour from',
    'work-hour-to': 'Work hour to',
    'doctorHobbies': 'Doctor hobbies',
    'visit-notes': 'Visit notes',
    // config translate
    'pharmacist-info': 'Pharmacist info',
    // config translate
    'pharmacy-info': 'Pharmacy info',
    // 'doctor-filter-in-customer-interface': 'Doctor filter in customer interface',
    // config translate
    'doctorNames': 'Doctor names',
    'specialty': 'specialty',
    'unavailable-materials': 'Unavailable materials',
    'competitive-samples': 'Competitive samples',
    'center-notes': 'Center notes',
    'phone-number': 'Phone number',
    'landline-number': 'Landline Number',
    'address': 'Address',
    'email': 'Email',
    'job-position': 'Job position',
    'facebook-profile-url': 'Facebook profile url',
    'starting-date': 'Starting date',
    'line-manager': 'Line manager',
    'role': 'role',
    'gender': 'Gender',
    'regions': 'Regions',
    'team': 'Team',
    'leave-days-number': 'Leave days number',   
    'username': 'username',
    'password': 'Password',
    'certificate': 'Certificate',
    'target-value': 'Target',
    'financial-target-value': 'Financial target value',
    'employee-type': 'Employee type',
    'leaves': 'Leaves',
    'add-leaves-for-staff': 'Add Leaves For Staff',
    'manage-leave-balances': 'Manage Leave Balances',
    'generate-materials': 'Generate Materials',
    'material-transactions': 'Material Transactions',
    'rep-plan': ' Rep plan',
    'rep-visits': 'Rep visits',
    'weekly-reports': 'Weekly Reports',
    'monthly-plan-reports': 'Monthly Plan Reports',
    'reviews': 'Reviews',
    'exams': 'Exams',
    'salaries': 'Salaries',
    'rep': 'Rep',
    'entities': 'Entities',
    'entity-modification-requests': 'Entity Modification Requests',
    'charts': 'charts',
    'users': 'Users',
    'roles': 'Roles', 
    'general-filter': 'General filter',
    'manage-team': 'Manage team',
    'entity': 'Entity',
    'free-sample': 'Free sample',
    'other-samples': 'Other samples',
    'notes': 'notes',
    'objections': 'Objections',
    'next-visit-notes': 'next visit notes',
    'purpose': 'purpose',
    'material-amount': 'Material amounts',
    'unavailable-material': 'Unavailable material',
    'core-message': 'Core message',
    'longitude': 'longitude',
    'latitude': 'latitude',
    'duration-in-minutes': 'Duration in minutes',
    'amount-received': 'Amount received',
    'residentDoctorNames': 'Resident doctor names',
    'payment': 'payment',
    'price-type': 'Price type',
    number: 'Number',
    'name': 'Name',
    'material-form': 'Material form',
    description: 'Description',
    'dose': 'Dose',
    'strength': 'Strength',
    'pills-per-box': 'Pills per box',
    'price': 'Price',
    'leaflet-file-path': 'Leaflet file path',
    'min-amount': 'min amount',
    'max-amount': 'max amount',
    'composition-per-unit': 'Composition per unit',
    'pharmacies-price': 'Pharmacies price',
    'price-types': 'Price Types',
    'price-discount-rate': 'Price discount rate',
    
    'type': 'Type',
    'entity-type': 'Entity type',
    'best-time-to-visit': 'Best time to visit',
    'opening-time': 'Opening time',
    'closing-time': 'Closing time',
    'resident-doctor-names': 'Resident doctor names',
    'contact-info': 'Contact info',
    'personal-note': 'Personal note',
    'doctor-hobbies': 'Doctor hobbies',
    'near-by-pharmacies': 'Near by pharmacies',
    'birthdate': 'birthdate',
    'work-hours-to': 'Work hours to',
    'work-hours-from': 'Work hours from',
    'please-select-a-section': 'Please select a section'
}